// HomePage — редирект на роле-домашнюю страницу.
// По просьбе заказчика (20.07.2026) главная — Тренажёр: заход на «/» открывает
// /trainer у всех ролей. Исключение — Куратор: у него в меню Тренажёра нет
// (помощник Создателя, работает с клиентами) → /tenants.

import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext.jsx';

const HOME_BY_ROLE = {
    creator: '/trainer',
    curator: '/tenants',
    admin: '/trainer',
    rop: '/trainer',
    mop: '/trainer',
};

export default function HomePage() {
    const { user } = useAuth();
    const target = HOME_BY_ROLE[user?.role] || '/trainer';
    return <Navigate to={target} replace />;
}
